import React, { useState } from 'react';

export const useMenuAnchor = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const handleClick: React.MouseEventHandler<any> = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return { anchorEl, handleClick, handleClose, isOpen };
};
